module.exports = __webpack_public_path__ + "assets/img/dhicon04.936fd4f4.png";